import { render, staticRenderFns } from "./addNotificationMaster.vue?vue&type=template&id=77351acc"
import script from "./addNotificationMaster.vue?vue&type=script&lang=js"
export * from "./addNotificationMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports